import toArray from 'lodash/toArray';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

function validateEmptyChecks(caseConf) {
  const nodes = toArray(get(caseConf, 'caseLogicDescription.nodes'));
  const checkNodes = nodes.filter(node => node.name === 'Check');

  const errors = [];
  const warnings = [];
  
  checkNodes.forEach((checkNode) => {
    if (isEmpty(checkNode.data)) {
        warnings.push(emptyCheckWarning(checkNode.id));
    }
  });
  return {
    errors,
    warnings,
  };
}

function emptyCheckWarning(nodeId) {
  return {
    message: 'Check node has no conditions.',
    category: 'caseLogic',
    field: 'caseLogicDescription',
    id: nodeId,
    metadata: {
      nodeId: nodeId,
      scope: 'node',
      defaultVisibility: false,
    },
  };
}

export default validateEmptyChecks;